export function normalizeScreeningSearch(value: string): string;
export function normalizeScreeningSearch(value?: string | null): string | null | undefined;
export function normalizeScreeningSearch(value?: string | null) {
  if (value == null) return value;
  const normalized = value.toString().trim().toLowerCase();
  if (normalized === "screened" || normalized === "screening" || normalized === "screene") {
    return "Screening";
  }
  return value;
}

export const buildFilterParamsWithScreeningSearch = (filter) => {
  const nextFilter = { ...filter };
  const normalizedQ = normalizeScreeningSearch(nextFilter.q);
  if (normalizedQ != null && normalizedQ !== "") {
    nextFilter.q = normalizedQ;
  } else {
    delete nextFilter.q;
  }
  return nextFilter;
};
